if(!customElements.get("layout-toggle")) {
  window.customElements.define("layout-toggle", class GridToggle extends HTMLElement {
    constructor() {
      super();

      this.gridToogles = this.querySelectorAll('#gridToogle');
      this.currentGrid = 'grid-regular-view';

      this.gridToogles.forEach( toogleButton => {
        toogleButton.addEventListener('click', this.onButtonClick.bind(this));
      })

    }

    onButtonClick(event) {
      event.preventDefault();

      if (this.currentGrid == 'large-grid') {
        this.gridToogles.forEach(() => {
          document.getElementById('ProductGridContainer').classList.add('grid-regular-view');
          document.getElementById('ProductGridContainer').classList.remove('grid-large-view');
        });

        this.currentGrid = 'grid-regular-view';

      } else {
        this.gridToogles.forEach(() => {
          document.getElementById('ProductGridContainer').classList.remove('grid-regular-view');
          document.getElementById('ProductGridContainer').classList.add('grid-large-view');
        });

        this.currentGrid = 'large-grid';
      }
    }
  })
}